import always from 'ramda/es/always';
import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  SELLPOINTS_FILTER_REQUEST,
  SELLPOINTS_FILTER_SUCCESS,
  SELLPOINTS_FILTER_FAILURE,
  SELLPOINTS_FILTER_CLEAR,
  SELLPOINTS_FILTER_DELETE,
  SELLPOINTS_FILTER_SET,
  SELLPOINTS_FILTER_UPDATE,
} from 'app/actions/reports/filters/sellPoints';


const defaultState = {
  data: {},
  selected: {},
  loading: true,
  active: false,
};

const sellPoints = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SELLPOINTS_FILTER_REQUEST: {
      return { ...state, loading: true };
    }
    case SELLPOINTS_FILTER_SUCCESS: {
      return evolve({
        data: always(payload),
        loading: always(false),
      }, state);
    }
    case SELLPOINTS_FILTER_FAILURE: {
      return { ...state, loading: false };
    }
    case SELLPOINTS_FILTER_CLEAR: {
      return defaultState;
    }
    case SELLPOINTS_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case SELLPOINTS_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    case SELLPOINTS_FILTER_UPDATE: {
      return { ...state, ...payload };
    }
    default:
  }
  return state;
};

export default sellPoints;
